export default __webpack_public_path__ + "static/media/PRESTIGIO_ARCADIA_120X278_001_265.4524b58a.jpg";